module.exports = __webpack_public_path__ + "static/media/Hbook-18.4cf3cd09.jpg";